import {ollehModule} from '../common/mapAPIExport'

const util = {
    /* 
    latlng(wgs84) --> UTMK  
    arg예 x=37, y=127
    ouput예 {x:957181, y: 1943712}
    */
    latlngToUtmk:(x, y)=>{ 
        let p = ollehModule.maps.UTMK.valueOf(new ollehModule.maps.LatLng(x, y))
        return {x:p.x, y:p.y}
    },

    /* 
    UTMK --> latlng(wgs84)  
    arg예 x=957181, y=1943712
    ouput예 {x:37, y: 127}
    */
    utmkToLatlng:(x, y)=>{
        let p = ollehModule.maps.LatLng.valueOf(new ollehModule.maps.UTMK(x, y))
        return {x:p.y, y:p.x } //x, y를 변경함 그래야 utmk와 동일험.
    },

    utmkToPoint:(x, y)=>{
        let p = ollehModule.maps.Point.valueOf(new ollehModule.maps.UTMK(x, y))
        return {x:p.x, y:p.y } 
    },

    guid:()=>{
        function s4() {
            return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },

    shapeToPolygons: (shape, _map)=>{
        let polygons = []
        let bound = null
        shape.coordinates.some((firstElement, idx) => {
            let pathArr = []
            firstElement.some((secondElement) => {
                let paths = []
                secondElement.some((point) => {
                    var utmk = ollehModule.maps.UTMK.valueOf(new ollehModule.maps.LatLng(point[1], point[0]))
                    paths.push(utmk);
                    bound = bound?bound.union(utmk):new ollehModule.maps.Bounds(utmk, utmk)
                })
                pathArr.push(paths)
            })
            polygons.push(util.makePolygon(pathArr, _map))
        })
        return {polygons:polygons, bound:bound}
    },

    makePolygon: (pathArr, map) =>{
        var paths = []
        pathArr.some((path) => {
            paths.push(new ollehModule.maps.Path(path))
        })
        var polygon = new ollehModule.maps.vector.Polygon({
            map: map,
            paths: paths,
            strokeWeight:2,
            strokeColor:'#7725ff',
            fillColor:'#7725ff',
            fillOpacity:0.3
        });
        return polygon;
    },

    shapeToPolyline: (shape, _map)=>{
        let polylines = []
        let bound = null;
        shape.coordinates.some((firstElement) => {
            let paths = [];
            firstElement.some((point) => {
                var utmk = ollehModule.maps.UTMK.valueOf(new ollehModule.maps.LatLng(point[1], point[0]));
                paths.push(utmk);
                bound = bound?bound.union(utmk):new ollehModule.maps.Bounds(utmk, utmk)
            })
            var polyline = new ollehModule.maps.vector.Polyline({
                map: _map,
                path: new ollehModule.maps.Path(paths),
                strokeWeight:6,
                strokeColor:'#7725ff',
                //strokeOpacity:0.8
            });
            polylines.push(polyline)
        })
        return {polylines:polylines, bound:bound}
    },

    tbtDisplayName: (tbts, startName, endName)=>{
        tbts.forEach((tbt) => {
            tbt['tbtInfoName'] = tbtTypeInfo['code_' + tbt.type]
            if(tbt.type>997){
                tbt['displayName'] = tbt['tbtInfoName']
                if(tbt.type===998){
                    tbt['tbtInfoName'] = startName
                }
                if(tbt.type===999 || tbt.type===1999){
                    tbt['tbtInfoName'] = endName
                }
                return false
            }
            if(tbt.tbtName){
                tbt['displayName'] = tbt.tbtName
                return false
            }
            if(tbt.shtDirName){
                tbt['displayName'] = tbt.shtDirName
                return false
            }
            if(tbt.midDirName){
                tbt['displayName'] = tbt.midDirName
                return false
            }
            if(tbt.lngDirName){
                tbt['displayName'] = tbt.lngDirName
                return false
            }
            tbt['displayName'] = tbt['tbtInfoName']
            tbt['tbtInfoName'] = ''
        })
    },

    jsLoader: (src, callback)=>{
        var head= document.getElementsByTagName('head')[0];
        var script= document.createElement('script');
        script.type= 'text/javascript';
        script.onreadystatechange = function () { // IE
            if (this.readyState === 'complete') callback();
        }
        script.onload = callback;
        script.src = src;
        head.appendChild(script);
    },
    
    getCurrentLocation:(callback)=>{
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(callback);
        }
    },

    delay:(gap)=>{ 
        var then,now; 
        then=new Date().getTime(); 
        now=then; 
        while((now-then)<gap){ 
          now=new Date().getTime();  
        } 
    },

    getFormatDate:(date)=>{
        let year = date.getFullYear();              //yyyy
        let month = (1 + date.getMonth());          //M
        month = month >= 10 ? month : '0' + month;  //month 두자리로 저장
        let day = date.getDate();                   //d
        day = day >= 10 ? day : '0' + day;          //day 두자리로 저장
        return  year + '-' + month + '-' + day;
    },

    dateDiff:(_date1, _date2)=>{
        let diffDate_1 = _date1 instanceof Date ? _date1 :new Date(_date1);
        let diffDate_2 = _date2 instanceof Date ? _date2 :new Date(_date2);
        diffDate_1 =new Date(diffDate_1.getFullYear(), diffDate_1.getMonth()+1, diffDate_1.getDate());
        diffDate_2 =new Date(diffDate_2.getFullYear(), diffDate_2.getMonth()+1, diffDate_2.getDate());
        let diff = Math.abs(diffDate_2.getTime() - diffDate_1.getTime());
        diff = Math.ceil(diff / (1000 * 3600 * 24));
        return diff;
    },

    yyyymmdd: (timestamp) => {
        var d = new Date(timestamp), // Convert the passed timestamp to milliseconds
        yyyy = d.getFullYear(),
        mm = ('0' + (d.getMonth() + 1)).slice(-2),  // Months are zero based. Add leading 0.
        dd = ('0' + d.getDate()).slice(-2),         // Add leading 0.
        hh = d.getHours(),
        h = hh,
        min = ('0' + d.getMinutes()).slice(-2),     // Add leading 0.
        ampm = 'AM',
        time;
            
        if (hh > 12) {
            h = hh - 12;
            ampm = 'PM';
        } else if (hh === 12) {
            h = 12;
            ampm = 'PM';
        } else if (hh == 0) {
            h = 12;
        }
        
        // ie: 2013-02-18, 8:35 AM
        time = yyyy + '' + mm + '' + dd;
        return time;
    },

    tbtIcon: {
        type_1: 'tkl_turn_code_16', //직진입니다

        type_4: 'tkl_turn_code_13', // 우회전입니다

        type_9: 'tkl_turn_code_12', // 좌회전입니다
        
        type_2: 'tkl_turn_code_17', // 1시방향입니다
        type_3: 'tkl_turn_code_17', // 2시방향입니다 
        type_20: 'tkl_turn_code_17', // 오른쪽도로
        type_33: 'tkl_turn_code_17', // 분기점에서오른쪽

        type_5: 'tkl_turn_code_21', //4시방향입니다
        type_6: 'tkl_turn_code_21', //5시방향입니다

        type_7: 'tkl_turn_code_23', //7시방향입니다
        type_8: 'tkl_turn_code_23', //8시방향입니다

        type_10: 'tkl_turn_code_27', //10시방향입니다
        type_11: 'tkl_turn_code_27', //11시방향입니다

        type_12: 'tkl_turn_code_28', //직진방향에고가도로로진입

        type_13: 'tkl_turn_code_30', //오른쪽방향에고가도로로진입

        type_14: 'tbt_overpass_left', //왼쪽방향에고가도로로진입

        type_16: 'tkl_turn_code_31', //오른쪽방향에고가도로옆도로

        type_17: 'tbt_overpass_leftside', //왼쪽방향에고가도로옆도로

        type_15: 'tkl_turn_code_34', //지하차도로진입

        type_19: 'tbt_underpass_leftside', //왼쪽방향에지하차도옆도로

        type_18: 'tkl_turn_code_37', //오른쪽방향에지하차도옆도로

        type_21: 'tkl_turn_code_27', //왼쪽도로
        type_34: 'tkl_turn_code_27', //분기점에서왼쪽

        type_22: 'tkl_turn_code_09', //직진방향에고속도로입구
        type_25: 'tkl_turn_code_09', //직진방향에도시고속도로입구

        type_23: 'tkl_turn_code_11', //오른쪽에고속도로입구
        type_26: 'tkl_turn_code_11', //오른쪽에도시고속도로입구

        type_24: 'tkl_turn_code_10', //왼쪽에고속도로입구
        type_27: 'tkl_turn_code_10', //왼쪽에도시고속도로입구

        type_28: 'tkl_turn_code_05', //오른쪽에고속도로출구입니다
        type_30: 'tkl_turn_code_05', //오른쪽에도시고속도로출구입니다

        type_29: 'tkl_turn_code_04', //왼쪽에고속도로출구입니다
        type_31: 'tkl_turn_code_04', //왼쪽에도시고속도로출구입니다

        type_32: 'tkl_turn_code_63', //분기점에서직진

        type_35: 'tkl_turn_code_14', //유턴입니다

        type_40: 'tkl_turn_code_46', //로터리에서1시방향입니다
        type_41: 'tkl_turn_code_46', //로터리에서2시방향입니다

        type_42: 'tkl_turn_code_48', //로터리에서3시방향입니다

        type_43: 'tkl_turn_code_49', //로터리에서4시방향입니다
        type_44: 'tkl_turn_code_49', //로터리에서5시방향입니다

        type_45: 'tbt_rotary_6', //로터리에서6시방향입니다

        type_46: 'tkl_turn_code_52', //로터리에서7시방향입니다
        type_47: 'tkl_turn_code_52', //로터리에서8시방향입니다

        type_48: 'tkl_turn_code_54', //로터리에서9시방향입니다

        type_49: 'tkl_turn_code_55', //로터리에서10시방향입니다
        type_50: 'tkl_turn_code_55', //로터리에서11시방향입니다

        type_51: 'tkl_turn_code_57', //로터리에서12시방향입니다

        type_998: 'ico_route_map_start', //출발지

        type_999: 'tkl_turn_code_60', //목적지
        type_1999: 'tkl_turn_code_60', //길건너 목적지

        type_1000: 'tkl_turn_code_78', //경유지
        type_2000: 'tkl_turn_code_78', //길건너 경유지

        type_52: 'tkl_turn_code_62', //interchange

        type_53: 'tkl_turn_code_65', //junction

        type_54: 'tkl_turn_code_43', //톨게이트

        type_55: 'tkl_turn_code_06', //휴게소

        type_37: 'tkl_turn_code_42', //터널

        type_2999: 'tkl_turn_code_ferry', //페리 항로 시작
        type_3000: 'tkl_turn_code_ferry', //페리 항로 끝
    }
}

let tbtTypeInfo = {
    code_0:'안내없음',
    code_1:'직진',
    code_2:'1시 방향 우회전',
    code_3:'2시 방향 우회전',
    code_4:'우회전',
    code_5:'4시 방향 우회전',
    code_6:'5시 방향 우회전',
    code_7:'7시 방향 좌회전',
    code_8:'8시 방향 좌회전',
    code_9:'좌회전',
    code_10:'10시 방향 좌회전',
    code_11:'11시 방향 좌회전',
    code_12:'직진 방향에 고가도로 진입',
    code_13:'오른쪽 방향에 고가도로 진입',
    code_14:'왼쪽 방향에 고가도로 진입',
    code_15:'지하차도',
    code_16:'오른쪽 방향에 고가도로 옆 도로',
    code_17:'왼쪽 방향에 고가도로 옆 도로',
    code_18:'오른쪽 방향에 지하차도 옆 도로',
    code_19:'왼쪽 방향에 지하차도 옆 도로',
    code_20:'오른쪽 도로',
    code_21:'왼쪽 도로',
    code_22:'직진 방향에 고속도로 진입',
    code_23:'오른쪽 방향에 고속도로 진입',
    code_24:'왼쪽 방향에 고속도로 진입',
    code_25:'직진 방향에 도시고속도로 진입',
    code_26:'오른쪽 방향에 도시고속도로 진입',
    code_27:'왼쪽 방향에 도시고속도로 진입',
    code_28:'오른쪽 방향에 고속도로 출구',
    code_29:'왼쪽 방향에 고속도로 출구',
    code_30:'오른쪽 방향에 도시고속도로 출구',
    code_31:'왼쪽 방향에 도시고속도로 출구',
    code_32:'분기점에서 직진',
    code_33:'분기점에서 오른쪽',
    code_34:'분기점에서 왼쪽',
    code_35:'U-TURN',
    code_36:'직진(무발성)',
    code_37:'터널',	 
    code_40:'로터리에서1시방향',	 
    code_41:'로터리에서2시방향',	 
    code_42:'로터리에서3시방향',	 
    code_43:'로터리에서4시방향',	 
    code_44:'로터리에서5시방향',	 
    code_45:'로터리에서6시방향',	 
    code_46:'로터리에서7시방향',	 
    code_47:'로터리에서8시방향',	 
    code_48:'로터리에서9시방향',	 
    code_49:'로터리에서10시방향',	 
    code_50:'로터리에서11시방향',	 
    code_51:'로터리에서12시방향',	 
    code_52:'IC',	 
    code_53:'JC',	 
    code_54:'TG',	 
    code_55:'SA',	 
    code_56:'교량',	 
    code_998:'출발',	 
    code_999:'도착',	 
    code_1000:'경유',	 
    code_1999:'길건너 목적지',	 
    code_2000:'길건너 경유지',	 
    code_2999:'Ferry 항로 시작',	 
    code_3000:'Ferry 항로 끝'
}

export default util